import { useIsomorphicLayoutEffect } from '@sail/engine';
import React from 'react';
export function useIntersectionObserver({ node, root, threshold, handler, disabled }) {
    useIsomorphicLayoutEffect(()=>{
        if (node && node.current && !disabled) {
            const observer = new IntersectionObserver((entries)=>{
                const entry = entries[0];
                handler(entry);
            }, {
                root,
                threshold
            });
            observer.observe(node.current);
            return ()=>observer.disconnect();
        }
    }, [
        node,
        root,
        disabled,
        threshold,
        handler
    ]);
}

//# sourceMappingURL=useIntersectionObserver.js.map